import { Capacitor } from "@capacitor/core";

/**
 * L'intestazione che dice al server della chat che la domanda arriva
 * dall'app iPhone, dove vale l'account gratuito (solo norme, 3 a settimana:
 * src/lib/iscrizione.ts). Le domande si contano per account.
 *
 * NIENTE IDENTIFICATIVO DEL TELEFONO (04/10/2026). Il 03/10 c'era anche un
 * numero casuale salvato sul telefono per contare per dispositivo: la privacy
 * dichiara che l'app non crea piu' numeri casuali (dal 26/08), e per Apple
 * sarebbe stato un «Device ID» da dichiarare nelle etichette. Tolto prima di
 * mandare la build ad Apple; il server lo accetta ancora ma non lo riceve.
 */
export function intestazioniPiattaforma(): Record<string, string> {
  return Capacitor.getPlatform() === "ios" ? { "x-piattaforma": "ios" } : {};
}
